module.exports = __webpack_public_path__ + "static/media/37-4.2800d288.mp3";